export default "__VITE_ASSET__46a33c94__"